const EthereumCnt = {
  symbol: "DOT",
  name: "polkadot",
  meta: {
    title: "Buy polkadot | Buy polkadot | polkadot prices and charts",
    description:
      "polkadot (DOT) connects blockchain networks to each other and is one of the leaders in the digital currency market. Experience buying and selling polkadot safely, quickly and at the best price at Kevin Nick Market.",
    keywords: "polkadot, Buy polkadot, Sell polkadot, polkadot Price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه پولکادات بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید  پولکادات کنید. قیمت پولکادات در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول پولکادات کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " بهترین کیف پول‌هایی که پولکادات را پشتیبانی می‌کنند عبارتند از: کیف پول سخت افزاری لجر(Ledger) و ترزور (Trezor)، کیف پول های موبایل تراست ولت (Trust Wallet)، اکسودوس (Exodus) و کیف پول‌های دات ولت (Dot Wallet)، مث ولت (Math Wallet)، متامسک (MetaMask)، فیری ولت (Fairy Wallet)، پاریتی ساینر (Parity Signer) و سیف پل (Safepal) و کیف پول کوین نیک مارکت.",
        },
      },
      {
        "@type": "Question",
        name: " آیا می‌توان پولکادات را در کوین نیک مارکت نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید رمزارزهیاتان را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا پولکادات ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " پولکادات ویژگی‌های منحصربه‌فردی دارد، مثل همین استفاده از چندین شبکه بلاکچین به صورت موازی. این ویژگی‌ها باعث شده تا شبکه پولکادات معایب شبکه‌های دیگر را نداشته باشد و از مزایای همه آن‌ها بهره ببرد. از طرفی سرعت بالای تراکنش‌ها و کارمزد پایین پولکادات را بسیار محبوب کرده است. رشد و گسترش نسل سوم وب نیز مزید بر علت شده است که پولکادات را به گزینه‌ای مناسبی برای سرمایه‌گذاری تبدیل کند.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy polkadot?",
      answer:
        "In coinnik Market trading market, you can buy polkadot with Shetab member bank card and the lowest fee. The price of Atrium in Quinnic Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best polkadot wallet?",
      answer: "polkadot_wallet",
      id: "toggler2",
    },
    {
      question: "Can polkadot be kept at Coinnik Market?",
      answer: "kept_polkadot",
      id: "toggler3",
    },
    {
      question: "Is polkadot Worth the Investment?",
      answer: "polkadot_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about polkadot",
        subTitle: "What is an polkadot?",
        content: "polkadot_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of polkadot",
        content: "polkadot_history_description",
        btnTitle: "Buy and sell polkadot Coin",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell without intermediaries polkadot in coinnik Market",
        subTitle: "Buy polkadot Coin",
        content: "Buy_polkadot_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sale polkadot",
        content: "sale_polkadot_description",
        btnTitle: "Buy and sell polkadot Coin",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest polkadot analysis on the blog",
  informationTitle: "polkadot market statistics and information",
};

export default EthereumCnt;
